export default __webpack_public_path__ + "static/media/popup-gratz.7ae52595849e9394d5cbc1f20263b45b.png";